/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import {
  baseApiV1,
  baseApiV2,
  connectorAddEdit,
  connectorDelete,
} from "../../constants/Presets";
import {
  CONNECTOR_ACTIVE,
  CONNECTOR_INACTIVE,
} from "../../constants/Constants";

// function that makes the api request and returns a Promise for response
export function FetchConnectors(payload) {
  const customerCode = payload.companyId || "";
  const url = `${connectorAddEdit}/list`;
  const { order } = payload;
  const page = payload.page || 0;
  const size = payload.size || 0;
  // const query = payload.query || ""
  const newquery =
    payload.query !== undefined && payload.query !== null
      ? encodeURIComponent(payload.query).toString()
      : "";
  const query = newquery;
  const { field } = payload;
  let disabled;
  if (payload.status !== "") {
    disabled = payload.status === 0;
  }
  let project_id;
  if (payload.projectId) {
    project_id = payload.projectId;
  }
  let filters;
  if (payload.filters) {
    filters = decodeURIComponent(JSON.stringify(payload.filters)) || null;
  }
  let initialLoad;
  if (payload.initialFilter) {
    initialLoad = true;
  }
  return axios.post(url, {
    query,
    disabled,
    company_id: customerCode,
    field,
    order,
    page,
    size,
    project_id,
    filters,
    initialLoad,
  });
}
export function FetchAConnector(connector) {
  const url = `${connectorAddEdit}/${connector}`;
  return axios({
    method: "get",
    url,
  });
}
export function ChangeConnectorStatus(connector) {
  const url = `${connectorAddEdit}/${connector.mappingId}`;
  const status =
    connector.configStatus === CONNECTOR_ACTIVE
      ? CONNECTOR_INACTIVE
      : CONNECTOR_ACTIVE;
  const params = {
    configStatus: status,
    mappingId: connector.mappingId,
    lastUpdatedBy: connector.lastUpdatedBy,
    metadata: connector.metadata,
  };
  return axios.patch(url, params);
}
export function CreateConnector(connector) {
  const url = `${connectorAddEdit}/create`;
  const params = {
    connectorId: connector.connectorId,
    dzConnectorId: connector.dzConnectorId,
    disabled: connector.disabled,
    companyId: connector.companyId,
    name: connector.name,
    metadata: connector.metadata,
    dzInternal: connector.dzInternal,
    samplingRate: connector.samplingRate,
    convertToDdv2: connector.dzDDV2Status,
    projectId: connector.projectId,
    timestampSource: connector.timestampSource,
  };
  return axios.post(url, params);
}
export function UpdateConnector(payload) {
  const url = `${connectorAddEdit}/update/${payload.id}`;
  return axios.patch(url, payload.connector);
}
export function ValidateConnector(connector) {
  const url = `${connectorAddEdit}/checkParamValidity`;
  return axios.post(url, connector);
}
export function DeleteConnector(connector) {
  const url = `${connectorDelete}${connector}`;
  return axios.delete(url);
}
export function UpdateLinkConnector(connector) {
  const url = `${connectorAddEdit}/update/${connector.connector.id}`;
  const params = {
    id: connector.connector.id,
    dzConnectorId: connector.connector.dzConnectorId,
    disabled: connector.connector.disabled,
    companyId: connector.connector.companyId,
    metadata: connector.connector.metadata,
    name: connector.connector.name,
    dzInternal: connector.connector.dzInternal,
    samplingRate: connector.connector.samplingRate,
    convertToDdv2: connector.connector.convertToDdv2,
    projectId: connector.connector.projectId,
  };
  return axios.patch(url, params);
}

export function ValidateNameConnector(connector) {
  const url = `${connectorAddEdit}/validateName`;
  const params = {
    companyId: connector.companyId,
    connectorId: connector.connectorId,
    configName: connector.configName,
  };
  return axios.get(url, {
    params,
  });
}

export function FetchAConnectorConfigStats(payload) {
  const url = `${baseApiV2}dataUsage/connector?`;
  const params = [];
  params.push(`from_date=${payload.fromDate}`);
  params.push(`to_date=${payload.toDate}`);
  params.push(`configuration_id=${payload.configId}`);
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}

export function FetchConnectorChangeLog(id) {
  const url = `${baseApiV1}connectorCustomerMap/changeLog/${id}`;
  return axios({
    method: "get",
    url,
  });
}

export function FetchBigQueryMappingTableData(payload) {
  const url = `${baseApiV1}bqFieldMapping/list`;
  return axios.post(url, payload);
}

export function BigqueryMappingUpdate(payload, id) {
  const url = `${baseApiV1}bqFieldMapping/update/${id}`;
  return axios.patch(url, payload);
}
